export default __webpack_public_path__ + "static/media/MHAPS.0f039d7d.png";